import Swiper from 'swiper';
import {
  A11y,
  Autoplay,
  EffectFade,
  Keyboard,
  Navigation,
  Pagination,
} from 'swiper/modules';

// Swiper 11.2.x exposes these files through package subpath exports, but
// Parcel's resolver can fail to resolve `swiper/css` on Windows. Import the
// exact package files so the vendor stays tree-shaken/minimal while bypassing
// that resolver issue.
import '../../node_modules/swiper/swiper.css';
import '../../node_modules/swiper/modules/effect-fade.css';
import '../../node_modules/swiper/modules/navigation.css';
import '../../node_modules/swiper/modules/pagination.css';

window.rebredgVendors = window.rebredgVendors || {};

window.rebredgVendors.Swiper = Swiper;
window.rebredgVendors.SwiperModules = {
  A11y,
  Autoplay,
  EffectFade,
  Keyboard,
  Navigation,
  Pagination,
};
